import { joinPath } from "@needle-tools/addressing";
import type { IObjectTargetProvider, OverTarget } from "../../editor/services/project/common/documentTarget.js";

/** Adds graph-owned objects to the existing document target provider registry. */
export class GraphObjectTargets implements IObjectTargetProvider {
    private readonly bindings = new WeakMap<object, { owner: WeakRef<object>; path: readonly string[] }>();

    constructor(private readonly ownerTarget: (owner: object) => OverTarget | null) {}

    bind(object: object, owner: object, path: readonly string[]): void {
        if (object !== owner) this.bindings.set(object, { owner: new WeakRef(owner), path: [...path] });
    }

    targetFor(object: object): OverTarget | null {
        const binding = this.bindings.get(object);
        const owner = binding?.owner.deref();
        if (!binding || !owner) return null;
        let current: unknown = owner;
        for (const segment of binding.path) {
            if (!current || typeof current !== "object") return null;
            current = (current as Record<string, unknown>)[segment];
        }
        if (current !== object) return null;
        const target = this.ownerTarget(owner);
        return target ? { ...target, pathPrefix: (target.pathPrefix ?? "") + joinPath(binding.path) + "/" } : null;
    }

    // Reference ownership and reverse resolution remain with the existing providers.
    ownsReference(): boolean { return false; }
    objectFor(): null { return null; }
}
